<template></template>

<script>
export default {
  props: ["chartData"],
  data() {
    return {
      chartInstance: null,
    };
  },
  watch: {
    chartData() {
      if (!this.chartInstance) {
        this.chartInstance = echarts.init(this.$el);
      }
      this.update()
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);

    import(/* webpackChunkName: "echarts" */"../../helpers/echarts").then(({default: echarts}) => {
      this.chartInstance = echarts.init(this.$el)
      this.update()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getAxis(){
      // if (window.innerWidth <= 948) {
        //   return {
        //     xAxis: {
        //       type: "value",
        //     },
        //     yAxis: {
        //       type: "category",
        //       data: this.chartData.labels,
        //     },
        //   };
        // } else {
        // }
        return {
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.chartData.labels,
            axisLabel: {
              show: true,
              interval: 0,
              rotate: 45,
            },
          },
          yAxis: {
            type: "value",
          },
        };
    },
    update(){
      const series = this.chartData.series.map(serie => {
        return {
          type: 'line',
          smooth: true,
          ...serie
        }
      })
      this.chartInstance.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
          formatter: function (params) {
            const total = params.reduce((total, item) => total + item.value, 0);
            const result = params.map(function (item) {
              return `<span style="width: 10px; height: 10px; border-radius: 50%; display: inline-block; margin-right: 4px; background-color: ${item.color}"></span>${item.seriesName}: ${item.value}`;
            });
            result.push(`Total: ${total}`);
            return result.join("<br>");
          }
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        ...this.getAxis(),
        series,
      });
    },
    handleResize() {
      if (!this.chartInstance) return
      this.chartInstance.resize();
      this.chartInstance.setOption(this.getAxis());
    }
  }
};
</script>
